var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"d-flex-column justify-center align-center"},[_c('div',{staticClass:"container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('lienVietConfig.infoValidationError'))+" !")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }